import pt from '../../locales/pt';

const SUBTITLE_KEYWORDS = [
  { keywords: ['necess', 'essencial', 'viver'], key: 'needs' },
  { keywords: ['desej', 'lazer', 'estilo', 'prazer'], key: 'wants' },
  { keywords: ['poupan', 'invest'], key: 'savings' },
];

export function resolveBudgetGroupSubtitle(group) {
  if (group?.description?.trim()) {
    return group.description.trim();
  }

  const name = (group?.name || '').toLowerCase();
  const match = SUBTITLE_KEYWORDS.find(({ keywords }) =>
    keywords.some((kw) => name.includes(kw)),
  );
  if (match) {
    return pt.budget.groupSubtitles[match.key];
  }
  return '';
}
